__turbopack_context__.v({
  "tableHeadContainer": "TableHead-module-scss-module__ee2HQG__tableHeadContainer",
});
